import { render, staticRenderFns } from "./add_subaccountlist_electron_pz.vue?vue&type=template&id=31b483d5&scoped=true&"
import script from "./add_subaccountlist_electron_pz.vue?vue&type=script&lang=js&"
export * from "./add_subaccountlist_electron_pz.vue?vue&type=script&lang=js&"
import style0 from "./add_subaccountlist_electron_pz.vue?vue&type=style&index=0&id=31b483d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b483d5",
  null
  
)

export default component.exports